import React, { createContext, useContext, useEffect, useState } from 'react';
import { applyTheme } from '../config/theme.config';

const ThemeContext = createContext();

export const ThemeProvider = ({ children, targetElement = null }) => {
  const [isDark, setIsDark] = useState(() => {
    const saved = localStorage.getItem("theme");
    if (saved) return saved === "dark";
    return window.matchMedia("(prefers-color-scheme: dark)").matches;
  });

  useEffect(() => {
    const element = targetElement || document.documentElement;
    applyTheme(isDark, element); // Pass element as parameter
    localStorage.setItem("theme", isDark ? "dark" : "light");
  }, [isDark, targetElement]);

  const toggleTheme = () => setIsDark((prev) => !prev);

  return (
    <ThemeContext.Provider value={{ isDark, toggleTheme }}>
      {children}
    </ThemeContext.Provider>
  );
};

export const useTheme = () => {
  const context = useContext(ThemeContext);
  if (!context) {
    throw new Error('useTheme must be used within a ThemeProvider');
  }
  return context;
};
